<template>
  <div class="input_group">
    <label>{{ label }} <span v-if="required">*</span></label>
    <input
      :type="type"
      v-bind="$attrs"
      @input="$emit('update:modelValue', $event.target.value)"
      :value="modelValue"
      :placeholder="Placeholder"
      :required="required"
      :class="inputClass"
    />
  </div>
</template>

<script>
export default {
  name: "f-input",
  props: {
    type: {
      type: String,
      default: "text",
    },
    modelValue: [String, Number],
    Placeholder: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      required: true,
    },
    inputClass: {
      type: String,
      default: "",
    },
    required:{
      type:Boolean,
      default:false
    },
  },
};
</script>

<style scoped>
.input_group {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  text-align: start;
  gap: 7px;
  width: 100%;
}

.input_group h2 {
  font-weight: 500;
  font-size: 24px;
  line-height: 40px;
}

.input_group label {
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  text-align: start;
}

.input_group label span {
  color: red;
}

.input_group input {
  width: 100%;
  text-indent: 10px;
  border-radius: 8px;
  border: 1px solid #ecebf2;
  padding: 11px 5px;
  font-family: var(--font-family);
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  box-shadow: 0 2px 4px 0 #0000000a;
  color: var(--dark-gray3);
  outline: none;
}

.input_group input:focus {
  border: 2px solid #0d3182;
}

.wrong {
  border: 1px solid red !important;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>